"use client";
import { SpaceMd, FontSize200, FontSize300 } from "@nxt-costco-com/forge-design-tokens";
const markdownStyles = {
  "&": {
    "#groceryFlyout ul li a": {
      fontSize: { lg: FontSize300, xs: FontSize200 }
    }
  },
  padding: { md: 0, xs: `0 ${SpaceMd}` }
};
export {
  markdownStyles
};
